import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes, css } from 'styled-components';

const transitionTime = '300ms';
const spinnerColor = '#1573a5';

const rota360 = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;
const SpinnerDiv = styled.div`
  position: relative;
  transform: translateZ(0);
  animation: ${rota360} 1.4s infinite linear;
  margin: auto;
  border-radius: 50%;
  width: 65px;
  height: 65px;
  font-size: 10px;
  text-indent: -9999em;
  background: ${spinnerColor};
  background: linear-gradient(
    to right,
    ${spinnerColor} 0%,
    ${({ theme }) => theme.colors.white}
  );
  opacity: 0;
  transition: ${transitionTime};
  visibility: hidden;

  &:before {
    position: absolute;
    top: 0;
    left: 50%;
    border-radius: 0 100% 0 0;
    width: 50%;
    height: 50%;
    background: ${({ theme }) => theme.colors.white};
    content: '';
  }
  &:after {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    border-radius: 50%;
    width: 75%;
    height: 75%;
    background: ${({ theme }) => theme.colors.white};
    content: '';
  }

  ${({ show }) => css`
    opacity: 1;
    visibility: visible;
  `}
`;

export default class Spinner extends PureComponent {
  render() {
    const { show, ...otherProps } = this.props;

    return <SpinnerDiv show={show} {...otherProps} />;
  }
}

Spinner.propTypes = {
  show: PropTypes.bool,
};

Spinner.defaultProps = {
  show: false,
};
